import { jsxs as C, jsx as l } from "react/jsx-runtime";
const i = () => /* @__PURE__ */ C(
  "svg",
  {
    width: "100",
    height: "100",
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M100 50C100 77.6145 77.6145 100 50 100C22.3855 100 0 77.6145 0 50C0 22.3855 22.3855 0 50 0C77.6145 0 100 22.3855 100 50Z",
          fill: "#F3F3FD"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          d: "M66.3407 43.4181C66.3407 33.7982 58.6679 26 49.2046 26H49.1346C39.6728 26 32 33.7982 32 43.4181C32 47.9088 33.4959 51.5718 36.434 55.0791C39.3706 58.5863 49.1703 67.9967 49.1703 67.9967C49.1703 67.9967 58.9716 58.5863 61.9067 55.0791C64.8433 51.5718 66.3407 47.9088 66.3407 43.4181Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M57.6504 37.4286C57.6504 31.1176 62.7671 26 69.079 26C75.39 26 80.5075 31.1176 80.5075 37.4286C80.5075 43.7404 75.39 48.8571 69.079 48.8571C62.7671 48.8571 57.6504 43.7404 57.6504 37.4286Z",
          fill: "var(--plac-icon-fill-active)"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M74.0687 34.4863C74.4592 34.8768 74.4592 35.5099 74.0687 35.9005L67.5656 42.4036L64.0887 38.9257C63.6982 38.5351 63.6983 37.9019 64.0889 37.5115C64.4795 37.121 65.1126 37.1211 65.5031 37.5117L67.5658 39.575L72.6545 34.4863C73.045 34.0957 73.6782 34.0957 74.0687 34.4863Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          d: "M53.0303 61.4323C55.8656 58.6232 58.9772 55.4632 60.3729 53.7955C62.0529 51.7891 63.1882 49.7723 63.7999 47.5675C64.3915 47.8761 65.0135 48.1345 65.6601 48.337C64.9529 50.7438 63.6974 52.9404 61.9067 55.0791C58.9716 58.5863 49.1703 67.9967 49.1703 67.9967C49.1703 67.9967 39.3706 58.5863 36.434 55.0791C33.4959 51.5718 32 47.9088 32 43.4181C32 33.7982 39.6728 26 49.1346 26H49.2046C53.429 26 57.2966 27.554 60.2842 30.1302C59.8559 30.6458 59.472 31.1996 59.1386 31.7857C56.4757 29.4256 52.9978 28 49.2046 28H49.1346C40.808 28 34 34.8718 34 43.4181C34 47.3825 35.2924 50.6019 37.9674 53.7951C39.3641 55.4631 42.4759 58.6234 45.311 61.4323C46.7136 62.8219 48.0254 64.103 48.9868 65.0369L49.1704 65.2152L49.3542 65.0368C50.3157 64.1029 51.6277 62.8218 53.0303 61.4323Z",
          fill: "var(--plac-primary-gray)"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M42.1602 43.4985C42.1602 39.5817 45.2807 36.374 49.1698 36.374C53.0589 36.374 56.1794 39.5817 56.1794 43.4985C56.1794 47.4154 53.0589 50.623 49.1698 50.623C45.2807 50.623 42.1602 47.4154 42.1602 43.4985ZM49.1698 38.374C46.4208 38.374 44.1602 40.6504 44.1602 43.4985C44.1602 46.3467 46.4208 48.623 49.1698 48.623C51.9187 48.623 54.1794 46.3467 54.1794 43.4985C54.1794 40.6504 51.9187 38.374 49.1698 38.374Z",
          fill: "var(--plac-primary-gray)"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          d: "M58.9242 73.9996H37.5908V71.7139H58.9242V73.9996Z",
          fill: "var(--plac-primary-gray)"
        }
      )
    ]
  }
);
export {
  i as PinSuccessIllustration
};
//# sourceMappingURL=index.es496.js.map
